import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import translate from '../../../../commonComponents/translate';
import OrderSummary from './OrderSummary';
import OrderProp from '../../propTypes/orderProp';
import DetailItem from '../DetailItem';
import ButtonsContainer from './ButtonsContainer';
import LoggedUserContext from '../../../../contextProviders/LoggedUserContext';

function SummaryContainer(props) {
  const { t, order, isAcademy, isOpportunity, onCreditNotesClick } = props;
  const { notes, adminNotes } = order;
  const { loggedUser } = useContext(LoggedUserContext);

  return (
    <div className="summary-container">
      <div className="notes-wrapper">
        {adminNotes ? (
          <div className="notes">
            <DetailItem header={t('order.notes.fromAdmin')} text={adminNotes} />
          </div>
        ) : null}
        {notes ? (
          <div className="notes">
            <DetailItem header={t('order.notes.fromUser')} text={notes} />
          </div>
        ) : null}
        <ButtonsContainer
          onCreditNotesClick={onCreditNotesClick}
          order={order}
          isOpportunity={isOpportunity}
        />
      </div>
      <OrderSummary
        user={loggedUser}
        order={order}
        isOpportunity={isOpportunity}
        isAcademy={isAcademy}
      />
    </div>
  );
}

SummaryContainer.propTypes = {
  t: PropTypes.func.isRequired,
  order: PropTypes.shape(OrderProp.propType).isRequired,
  isAcademy: PropTypes.bool,
  isOpportunity: PropTypes.bool,
  onCreditNotesClick: PropTypes.func.isRequired,
};

SummaryContainer.defaultProps = {
  isAcademy: false,
  isOpportunity: false,
};

export default translate(SummaryContainer);
